import {
  fetchClient
} from "./chunk-K342ITN7.mjs";
import {
  ApiConfig
} from "./chunk-LPIRJEMY.mjs";
import {
  __async
} from "./chunk-DFMI36TU.mjs";

// src/core/wbk/teams/list.ts
import { getLocaleOnly } from "@wbk/utils";
import { Exception } from "@wbk/logger";
var getTeams = (_0) => __async(void 0, [_0], function* ({ lang, page, perPage }) {
  var _a, _b;
  try {
    const locale = getLocaleOnly(lang);
    const search = new URLSearchParams();
    search.set("visible_in", ((_b = (_a = ApiConfig.config) == null ? void 0 : _a.wbk) == null ? void 0 : _b.appSource) || "");
    search.set("lang", locale);
    if (page) {
      search.append("page", page.toString());
    }
    if (perPage) {
      search.append("per_page", perPage.toString());
    }
    const data = yield fetchClient({
      url: `/teams/list?${search.toString()}`
    });
    return data.data;
  } catch (error) {
    throw new Exception({ error, name: "getTeamsException" });
  }
});

export {
  getTeams
};
//# sourceMappingURL=chunk-KXRLHAPZ.mjs.map